module.exports = __webpack_public_path__ + "static/media/leftsun.34197f79.png";